import React, { useState } from "react";
import partnershipService from "../../../apis/Partnerships/partnershipService";
import "../PartnershipDetail/PartnershipDetail.css";
import "../PartnershipForm/PartnershipForm.css";

const TOPICS = [
  "Take-back / Circularity",
  "Product inquiry",
  "Certifications",
  "Materials",
  "Quote enquiry",
  "Other",
];

const YFSSpecialOfferForm = ({ partnership }) => {
  const [senderEmail, setSenderEmail] = useState("");
  const [senderPhone, setSenderPhone] = useState("");
  const [topic, setTopic] = useState("");
  const [message, setMessage] = useState("");
  const [contactMethod, setContactMethod] = useState({
    email: true,
    phone: false,
  });
  const [slider, setSlider] = useState("in_a_hurry");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [textareaFocused, setTextareaFocused] = useState(false);

  const handleContactMethodChange = (method) => {
    setContactMethod((prev) => ({ ...prev, [method]: !prev[method] }));
  };

  const validate = () => {
    if (!contactMethod.email && !contactMethod.phone) return false;
    if (contactMethod.email && !senderEmail) return false;
    if (contactMethod.phone && !senderPhone) return false;
    if (!topic) return false;
    if (!message) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccess(null);
    setError(null);
    try {
      await partnershipService.sendYFSSpecialOffer({
        partnership_id: partnership.id,
        sender_email: senderEmail,
        sender_phone: senderPhone,
        topic,
        message,
      });
      setSuccess("Your request has been sent!");
      setSenderEmail("");
      setSenderPhone("");
      setTopic("");
      setMessage("");
      setContactMethod({ email: true, phone: false });
    } catch (err) {
      setError("Failed to send. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="partnership-detail-featured-bg"
      style={{ maxWidth: "300px" }}
    >
      <form className="yfs-special-offer-form" onSubmit={handleSubmit}>
        <div className="yfs-special-offer-title">YFS Special Offer</div>
        <div className="yfs-special-offer-desc">
          Get a 10% discount with YFS. Use the form below mentioning the product
          from selection on the left you wish to avail of the offer.
        </div>
        <div
          className="yfs-special-offer-desc yfs-special-offer-fields-bg"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="yfs-special-offer-row">
            <select
              className="yfs-special-offer-topic"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              required
            >
              <option value="" disabled>
                Topic of request
              </option>
              {TOPICS.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
          <div className="yfs-special-offer-row">
            <div style={{ position: "relative" }}>
              {!textareaFocused && !message && (
                <div
                  className="yfs-special-offer-textarea-placeholder"
                  style={{
                    position: "absolute",
                    top: 10,
                    left: 14,
                    color: "#09366B",
                    fontSize: 12,
                    pointerEvents: "none",
                    zIndex: 2,
                    background: "transparent",
                  }}
                >
                  Text Field
                </div>
              )}
              <textarea
                className="yfs-special-offer-message"
                value={message}
                onFocus={() => setTextareaFocused(true)}
                onBlur={() => setTextareaFocused(false)}
                onChange={(e) => setMessage(e.target.value)}
                required
                style={{ color: "#09366B", fontSize: 12, background: "white" }}
              />
            </div>
          </div>
          <div className="yfs-special-offer-row yfs-special-offer-contact-methods">
            <label className="yfs-checkbox-label">
              <input
                type="checkbox"
                checked={contactMethod.email}
                onChange={() => handleContactMethodChange("email")}
              />
              Email
            </label>
            <label className="yfs-checkbox-label">
              <input
                type="checkbox"
                checked={contactMethod.phone}
                onChange={() => handleContactMethodChange("phone")}
              />
              Phone
            </label>
          </div>
          {contactMethod.email && (
            <div className="yfs-special-offer-row">
              <input
                type="email"
                className="yfs-special-offer-input"
                placeholder="Your email"
                value={senderEmail}
                onChange={(e) => setSenderEmail(e.target.value)}
                required={contactMethod.email}
              />
            </div>
          )}
          {contactMethod.phone && (
            <div className="yfs-special-offer-row">
              <input
                type="tel"
                className="yfs-special-offer-input"
                placeholder="Your phone number"
                value={senderPhone}
                onChange={(e) => setSenderPhone(e.target.value)}
                required={contactMethod.phone}
              />
            </div>
          )}
          {/* Slider for In a hurry / Doing research */}
          <div
            className="partnership-slider-container"
            style={{ width: "100%" }}
          >
            <button
              type="button"
              className={`partnership-slider-option${
                slider === "in_a_hurry" ? " active" : ""
              }`}
              onClick={() => setSlider("in_a_hurry")}
            >
              In a hurry
            </button>
            <button
              type="button"
              className={`partnership-slider-option${
                slider === "doing_research" ? " active" : ""
              }`}
              onClick={() => setSlider("doing_research")}
            >
              Doing research
            </button>
          </div>
        </div>
        <div className="yfs-special-offer-actions">
          <button
            type="submit"
            className="yfs-special-offer-send-btn"
            disabled={submitting || !validate()}
          >
            Send
          </button>
        </div>
        {success && <div className="yfs-special-offer-success">{success}</div>}
        {error && <div className="yfs-special-offer-error">{error}</div>}
      </form>
    </div>
  );
};

export default YFSSpecialOfferForm;
